module.exports = __webpack_public_path__ + "static/media/comment-alt-smile.f80d7fa6.svg";